<template>
     <div>我是部门管理</div>
</template>
<!-- <script type="text/ecmascript-6"> -->
<script>
export default {
    data () {
	    return {
	       
	    }
	 },
    methods: {
       
    }
}
</script>
<style>
    
</style>



// WEBPACK FOOTER //
// Department.vue?73efc529